(function () {
    'use strict';

    angular
        .module('app')
        .directive('selectioncommandfinalapprove', selectioncommand_finalapprove);

    selectioncommand_finalapprove.$inject = ['$window'];

    function selectioncommand_finalapprove($window) {
        // Usage:
        //     <toolbar></toolbar>
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                finalApproveDialogShown: '=?'
            },
            controller: 'finalApprove',
            templateUrl: 'app/selectioncommand/selectioncommand_finalapprove.html'
        };
        return directive;

        function link(scope, element, attrs) {

            

        }
    }
})();